"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.synapse = void 0;
exports.synapse = {
    chef: '0x3a01521F8E7F012eB37eAAf1cb9490a5d9e18249', // MiniChefV2
};
